// Removes kerning preview spans (<span data-kerning="1" ...>X</span>) emitted
// by applyKerningOverrides. Round-trip invariant: strip(wrap(html, overrides))
// equals html for any html / overrides pair. The string-based fast path is
// safe because applyKerningOverrides always wraps a single text character
// (no nested HTML inside the span). The DOM-based variant is exposed for
// in-place strip on a live element when a string round-trip would normalize
// surrounding markup.

const KERNING_SPAN_REGEX = /<span\b([^>]*?)\sdata-kerning="1"([^>]*)>([^<]*)<\/span>/g;
const KERNING_SPAN_REGEX_LEAD = /<span\s+data-kerning="1"([^>]*)>([^<]*)<\/span>/g;

export const stripKerningOverridesHTML = (html: string): string => {
  if (!html || !html.includes("data-kerning")) return html;
  return html
    .replace(KERNING_SPAN_REGEX_LEAD, (_match, _attrs, text) => text)
    .replace(KERNING_SPAN_REGEX, (_match, _before, _after, text) => text);
};

export const stripKerningSpansFromElement = (root: Element): void => {
  const spans = root.querySelectorAll<HTMLElement>('span[data-kerning="1"]');
  spans.forEach(span => {
    const parent = span.parentNode;
    if (!parent) return;
    while (span.firstChild) {
      parent.insertBefore(span.firstChild, span);
    }
    parent.removeChild(span);
  });
  root.normalize();
};
